<div class="prd">
  <app-container>
    <app-bread-crumbs></app-bread-crumbs>

    <h4 class="prd-title">{{ this.page?.translation?.data?.searchTitle }}</h4>
    <div class="prd-search">
      <app-search-input
        [placeholder]="page?.translation?.data?.searchPlaceholder"
        [variant]="'second'"
        (onSearch)="onSearch($event)"
      ></app-search-input>

      <app-filters
        [title]="page?.translation?.data?.filterButtonTitle"
        [filterOptions]="filterOptions"
        [appliedFilters]="appliedFilters"
        (filtersChanged)="onFiltersChanged($event)"
      ></app-filters>
    </div>
  </app-container>
  @if (paginatedPrd.length) {
    <app-regulatory-activity-list [prdList]="paginatedPrd" />

    <app-paginator
      [totalItems]="totalItems"
      [currentPage]="currentPage"
      [itemsPerPage]="itemsPerPage"
      (pageChange)="onPageChange($event)"
    >
    </app-paginator>
  } @else {
    <app-container> <h6 class="h6 empty">Не знайдено</h6></app-container>
  }
</div>
